/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {useIntl} from 'react-intl'

import {
    Box,
    Link,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'

export const LegalLink = () => {
    const {formatMessage} = useIntl()

    return (
        <Box marginY="15px">
            <Text
                fontSize="10px"
                fontFamily="Roboto"
                fontWeight="300"
                textAlign="center"
            >
                {formatMessage(
                    {
                        defaultMessage:
                            "By signing up, I'm agreeing to Rennaï's <terms>Terms & Conditions</terms>, <teams>Membership Terms</teams> and <policy>Privacy Policy</policy>.",
                        id: 'newsletter.legals'
                    },
                    {
                        terms: (chunks) => (
                            <Link
                                href="/pages/legals?section=termsOfUse"
                                textDecoration="underline"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        ),
                        support: (chunks) => (
                            <Link
                                href="mailto:support@rennai.com"
                                textDecoration="none"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        ),
                        policy: (chunks) => (
                            <Link
                                href="/pages/legals?section=privacyPolicy"
                                textDecoration="underline"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        )
                    }
                )}
            </Text>
        </Box>
    )
}
